export default "__VITE_ASSET__BD_d0U_J__"